module.exports = __webpack_public_path__ + "img/account-icon@2x.32d87deb02b3d1c3cc5bcff0c26314ac.32d87deb.png";